var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBarcodeIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#4d4c4d",
  d: "M31.627 39.108H8.372a7.48 7.48 0 0 1-7.48-7.48V8.371a7.48 7.48 0 0 1 7.48-7.48h23.255a7.48 7.48 0 0 1 7.481 7.48v23.255a7.48 7.48 0 0 1-7.48 7.481"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M28.065 26.498V23.26h1.62v3.238a1.62 1.62 0 0 1-1.62 1.62h-3.238v-1.62zM11.876 23.26v3.238h3.238v1.62h-3.238a1.62 1.62 0 0 1-1.62-1.62V23.26zm16.189-11.333c.893 0 1.62.726 1.62 1.62v3.238h-1.62v-3.238h-3.238v-1.62zm-16.189 1.62v3.238h-1.62v-3.238c0-.894.726-1.62 1.62-1.62h3.238v1.62zm13.761 11.332h.81v-9.714h-.81zm-2.428 0h1.618v-9.714h-1.618zm-2.429 0h.81v-9.714h-.81zm-3.238 0h2.429v-9.714h-2.429zm-1.619 0h.81v-9.714h-.81zm-2.427 0h1.619v-9.714h-1.62z"
}))));
export default SvgBarcodeIcon;